var _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataflowDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 350 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 163.516,
    cy: 160.051,
    fill: "#11141a",
    r: 91.3074
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#505666",
    strokeWidth: 2.28269
  }, /*#__PURE__*/React.createElement("path", {
    d: "m155.768 161.354c4.546 0 8.231 3.685 8.231 8.232v42.139c0 4.302 3.488 7.79 7.789 7.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.286 161.354h17.541 21.925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156 161c4.173 0 7.556-3.383 7.556-7.556v-42c0-5.216 4.228-9.444 9.444-9.444"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m307.168 77.7478h-132.473c-2.71 0-4.907 3.0557-4.907 6.825v34.1252c0 3.769 2.197 6.825 4.907 6.825h132.473c2.71 0 4.906-3.056 4.906-6.825v-34.1252c0-3.7693-2.196-6.825-4.906-6.825z",
    fill: "#2d323d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m265.373 88.6797h-35.081c-2.236 0-4.048 1.8195-4.048 4.064s1.812 4.064 4.048 4.064h35.081c2.236 0 4.048-1.8195 4.048-4.064s-1.812-4.064-4.048-4.064z",
    fill: "#505666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m289.66 106.291h-59.368c-2.236 0-4.048 1.819-4.048 4.064 0 2.244 1.812 4.064 4.048 4.064h59.368c2.235 0 4.048-1.82 4.048-4.064 0-2.245-1.813-4.064-4.048-4.064z",
    fill: "#383d4d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m198.477 114.419c7.079 0 12.818-5.762 12.818-12.87 0-7.1075-5.739-12.8693-12.818-12.8693s-12.818 5.7618-12.818 12.8693c0 7.108 5.739 12.87 12.818 12.87z",
    fill: "#505666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m332.094 137.986h-132.474c-2.709 0-4.906 3.055-4.906 6.825v34.125c0 3.769 2.197 6.825 4.906 6.825h132.474c2.709 0 4.906-3.056 4.906-6.825v-34.125c0-3.77-2.197-6.825-4.906-6.825z",
    fill: "#2d323d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m290.299 148.918h-35.081c-2.236 0-4.048 1.819-4.048 4.064 0 2.244 1.812 4.064 4.048 4.064h35.081c2.235 0 4.048-1.82 4.048-4.064 0-2.245-1.813-4.064-4.048-4.064z",
    fill: "#505666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m314.586 166.529h-59.368c-2.236 0-4.048 1.819-4.048 4.064 0 2.244 1.812 4.064 4.048 4.064h59.368c2.235 0 4.048-1.82 4.048-4.064 0-2.245-1.813-4.064-4.048-4.064z",
    fill: "#383d4d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m223.403 174.657c7.079 0 12.818-5.762 12.818-12.87 0-7.107-5.739-12.869-12.818-12.869s-12.818 5.762-12.818 12.869c0 7.108 5.739 12.87 12.818 12.87z",
    fill: "#505666"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m307.168 195.108h-132.473c-2.71 0-4.907 3.056-4.907 6.825v34.125c0 3.769 2.197 6.825 4.907 6.825h132.473c2.71 0 4.906-3.056 4.906-6.825v-34.125c0-3.769-2.196-6.825-4.906-6.825z",
    fill: "#2d323d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m265.373 206.04h-35.081c-2.236 0-4.048 1.819-4.048 4.064 0 2.244 1.812 4.064 4.048 4.064h35.081c2.236 0 4.048-1.82 4.048-4.064 0-2.245-1.812-4.064-4.048-4.064z",
    fill: "#505666"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m289.66 223.651h-59.368c-2.236 0-4.048 1.819-4.048 4.064 0 2.244 1.812 4.064 4.048 4.064h59.368c2.235 0 4.048-1.82 4.048-4.064 0-2.245-1.813-4.064-4.048-4.064z",
    fill: "#383d4d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m198.477 231.779c7.079 0 12.818-5.762 12.818-12.87 0-7.107-5.739-12.869-12.818-12.869s-12.818 5.762-12.818 12.869c0 7.108 5.739 12.87 12.818 12.87z",
    fill: "#505666"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m151.38 136.947h-132.4736c-2.7097 0-4.9064 3.056-4.9064 6.825v34.125c0 3.77 2.1967 6.825 4.9064 6.825h132.4736c2.709 0 4.906-3.055 4.906-6.825v-34.125c0-3.769-2.197-6.825-4.906-6.825z",
    fill: "#2d323d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m109.585 147.879h-35.0811c-2.2356 0-4.0478 1.82-4.0478 4.064 0 2.245 1.8122 4.064 4.0478 4.064h35.0811c2.235 0 4.048-1.819 4.048-4.064 0-2.244-1.813-4.064-4.048-4.064z",
    fill: "#505666"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m133.872 165.49h-59.3681c-2.2356 0-4.0478 1.82-4.0478 4.064 0 2.245 1.8122 4.064 4.0478 4.064h59.3681c2.235 0 4.048-1.819 4.048-4.064 0-2.244-1.813-4.064-4.048-4.064z",
    fill: "#383d4d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m42.6892 173.618c7.0792 0 12.8181-5.762 12.8181-12.869 0-7.108-5.7389-12.87-12.8181-12.87-7.0793 0-12.8181 5.762-12.8181 12.87 0 7.107 5.7388 12.869 12.8181 12.869z",
    fill: "#505666"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataflowDark);
export default __webpack_public_path__ + "static/media/DataflowDark.8199aee57e94e36b6eccf3167e7bf2b1.svg";
export { ForwardRef as ReactComponent };